import RenderComponent from '@/modules/DynamicRenderPage';
import { loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useEffect } from 'react';
import { connect } from 'react-redux';
import ParentStyled from './style';

let Styled = loadStyle(ParentStyled, 'pages/web/HardDeceleration');
const config = loadPageConfig();
const Title = lazy(() => import(`globalcomponents/Title`));
const Content = lazy(() => import(`@/${config.hardDeceleration[1].name}`));
const TopActions = config.hardDeceleration[0].children && lazy(() => import(`${config.hardDeceleration[0].children.name}`));

const HardDeceleration = (parentProps) => {
  const {
    history,
    i18n,
    theme,
    getDrivers,
    getVehicleListDropDown,
    driverbehavior,
    fetchDriverBehaviorDetails,
    fetchTableData,
    chat,
    vehicleListDropDown,
  } = parentProps;

  useEffect(() => {
    getDrivers({ apiId: 'getDrivers' });
    getVehicleListDropDown({ apiId: 'getVehicleListDropDown' });
    fetchDriverBehaviorDetails({
      apiId: 'fetchDriverDetails',
    });
    fetchTableData({
      apiId: 'fetchTableData',
      data: {
        endDate: '',
        startDate: '',
        id: '',
      },
      type: 'hardDecceleration',
    });
  }, []);

  const commonParentProps = { history, i18n, Styled, theme };

  const formatDataForChart = (responseData) => {
    let tempData = {
      labels: [],
      data: [],
    };
    if (responseData) {
      responseData.forEach(function (item) {
        tempData['labels'].push(item.date);
        tempData['data'].push(item.count);
      });
    }
    return tempData;
  };

  const hardDecelerationData = formatDataForChart(driverbehavior.hardDeceleration.chart);

  const objectArrayFromDiffFields = (list, value, field1, field2, callback) => {
    return list?.length
      ? list.map((item) => {
          if (callback) return callback(item, field1, field2, value);
          else
            return {
              label: field2 ? `${item[field1]} ${item[field2]}` : item[field1],
              value: item[value],
            };
        })
      : [];
  };

  const driverList = objectArrayFromDiffFields(chat?.drivers, 'userId', 'firstName', 'lastName');

  const vehicleListDropDownDF = objectArrayFromDiffFields(
    vehicleListDropDown.filter((el) => !!el.esn || !!el.cameraSerialNo),
    'vehicleId',
    'name'
  );

  return (
    <>
      <RenderComponent
        {...config.hardDeceleration[0]}
        parentProps={{
          ...parentProps,
          driverList,
        }}
        commonParentProps={commonParentProps}
        component={Title}
        childComponent={TopActions}
      />
      <RenderComponent
        {...config.hardDeceleration[1]}
        parentProps={{ ...parentProps, driverList, vehicleListDropDown: vehicleListDropDownDF, vehicleList: vehicleListDropDown }}
        commonParentProps={commonParentProps}
        component={Content}
        chartData={hardDecelerationData}
        tableData={driverbehavior.hardDeceleration.table}
        driverbehavior={driverbehavior}
      />
    </>
  );
};

const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    chat: state.chat,
    driverbehavior: state.driverbehavior,
    vehicleListDropDown: state?.vehicles?.vehicleListDropDown,
  };
};
const mapDispatch = (dispatch) => {
  return {
    clearApiStatus: () => dispatch.asyncRequests.clearApiStatus(),
    getDrivers: (data) => dispatch.chat.getDrivers(data),
    getVehicleListDropDown: (data) => dispatch.vehicles.fetchVehicleListDropDown(data),
    fetchDriverBehaviorDetails: (data) => dispatch.driverbehavior.fetchDriverBehaviorDetails(data),
    fetchTableData: (data) => dispatch.driverbehavior.fetchTableData(data),
    fetchChartData: (data) => dispatch.driverbehavior.fetchChartData(data),
  };
};

export default connect(mapState, mapDispatch)(HardDeceleration);
HardDeceleration.propTypes = {
  apiStatus: PropTypes.object.isRequired,
};
